import React, { useState } from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, Collapse } from '@mui/material';
import LandingNavbar from './LandingPageNavBar';

const AboutUsPage = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  return (
    <>
      <LandingNavbar />
      <Box sx={{ bgcolor: 'rgba(142,81,255,0.85)', color: '#fff', pt: 16, pb: 12, px: 3 }}>
        <Container maxWidth="md">
          <Typography variant="overline" color="rgba(255,255,255,0.7)">
            Our Story
          </Typography>
          <Typography variant="h3" fontWeight={700} gutterBottom>
            A healthcare partner built for the modern age of support.
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Delight Supported Living began with a promise: adults with complex needs deserve the same innovation
            and compassion that leading hospitals receive. Today, multidisciplinary teams unite digital monitoring,
            regulated carers, and family portals so people can live safely at home.
          </Typography>
        </Container>
      </Box>

      <Box sx={{ py: 10, bgcolor: '#f5f6fb' }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {[
              {
                title: 'Regulated teams across the UK',
                text: 'CQC registered service with nurses, behavioural specialists, and care coordinators.',
              },
              {
                title: 'Evidence-based pathways',
                text: 'Collaborations with NHS clinicians to capture and escalate falls, health changes, or safeguarding concerns.',
              },
              {
                title: 'Family-first communication',
                text: 'Secure notifications and dashboards mean loved ones never feel out of the loop.',
              },
              {
                title: 'Partnership with commissioners',
                text: 'Outcome data, reporting, and budgeting in one place for local authorities and housing associations.',
              },
            ].map((item, idx) => (
              <Grid item xs={12} md={6} key={item.title}>
                <Card
                  onClick={() => setExpandedCard(expandedCard === idx ? null : idx)}
                  sx={{
                    borderRadius: 4,
                    p: 2,
                    minHeight: 120,
                    maxWidth: 360,
                    boxShadow: '0 20px 35px rgba(11,13,33,0.08)',
                    cursor: 'pointer',
                    mx: 'auto',
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" fontWeight={700}>
                      {item.title}
                    </Typography>
                    <Collapse in={expandedCard === idx}>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {item.text}
                      </Typography>
                    </Collapse>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default AboutUsPage;
